import React, { Component } from "react";
import "./CarFormNumbers.css";

class CarFormNumbers extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="CarFormNumbers">
        <div
          className={
            this.props.step == 1 ? "CarFormNumberSelected" : "CarFormNumber"
          }
        >
          01
        </div>
        <div
          className={
            this.props.step == 2 ? "CarFormNumberSelected" : "CarFormNumber"
          }
        >
          02
        </div>
        <div
          className={
            this.props.step == 3 ? "CarFormNumberSelected" : "CarFormNumber"
          }
        >
          03
        </div>
      </div>
    );
  }
}

export default CarFormNumbers;
